import { Box } from "@mui/material";

function FilePreview({ report }) {
  if (!report) return null;

  const apiBaseUrl = process.env.REACT_APP_BE_BASE_URL;

  const serverBaseUrl = apiBaseUrl.replace("/api", "");

  const fileUrl = `${serverBaseUrl}/uploads/${report.file_name}`;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#fff",
      }}
    >
      {report.mime_type?.startsWith("image/") ? (
        <img
          src={fileUrl}
          alt={report.original_file_name}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      ) : (
        <iframe
          src={fileUrl}
          title="preview"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      )}
    </Box>
  );
}

export default FilePreview;
